import React, {useEffect, useState} from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

import Button from "../components/Button";
import styles from "../styles/Welcome.module.scss";
import MessageBubble from "../components/MessageBubble";

import {UserData, WelcomeStep} from "../services/types";
import {json} from "stream/consumers";
import { useSound } from '../context/SoundContext';
const base = process.env.PUBLIC_URL || ``;


const steps: WelcomeStep[] = [
    {
        name: '',
        text: 'Северокрайск. Город, где бушует снежная метель, а северное сияние мерцает в окнах поликлиники. Вы здесь  — единственный гематолог. Диагностируйте ПНГ вовремя, делайте верные назначения и меняйте жизни к лучшему. Начните свою первую консультацию прямо сейчас! Жмите START!',
        positionTop: true,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "START", type: "nextStep", gotoStep:"1", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/city.jpg`,
    },
    {
        name: '',
        text: '<strong>🩸Добро пожаловать в первую интерактивную практику для гематологов!</strong><br>🎯 У Вас есть отличная возможность ознакомиться с аспектами диагностики и лечения пациентов <strong>с пароксизмальной ночной гемоглобинурией (ПНГ)!</strong><br><br>📚 Учитесь. 🔍 Исследуйте. 🏥 Лечите.<br><br><i>Помните: все персонажи вымышлены, все совпадения случайны.</i>',
        positionTop: true,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"2", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/train.jpg`,
    },
    {
        name: '',
        text: 'Вы — редкий специалист, и Вас ждут везде. Даже на краю света.<br><br>А вот и он — Северокрайск! Приехали! 🚂',
        positionTop: true,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Выйти с вокзала", type: "nextStep", gotoStep:"3", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/train.jpg`,
    },
    {
        name: '',
        text: '<strong>«Стойте!»</strong> - вас окликает девушка с табличкой «ЛПУ Северокрайска».',
        positionTop: true,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"4", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/train2.jpg`,
    },
    {
        name: '',
        text: 'Простите, это, наверное, Вы - гематолог, которого мы ждем? Да?<br><br><i>(Подтвердите, что являетесь сотрудником здравоохранения)</i>',
        positionTop: true,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Да", type: "nextStep", gotoStep:"6", value: false, redColor: false, answered: false},
            {text: "Нет", type: "nextStep", gotoStep:"1", value: true, redColor: false, answered: false}
        ],
        background: `${base}/images/welcom_woman.jpeg`,
    },
    {
        name: '',
        text: '<span style="font-size: 12px; line-height: 14px;"><b style="font-size: 12px; line-height: 14px;">Материал подготовлен ООО «Новартис Фарма»</b><br>Материалы, размещенные на сайте, предназначены только для медицинских и фармацевтических работников. Для распространения на территории РФ. Использованные изображения не являются изображениями реальных пациентов.<br><br>Клинические случаи подготовлен компанией «Новартис». Материал предназначен для информационных целей. Не у всех пациентов будет отмечаться сходная клиническая картина или ответ на терапию.<br><br>Все персонажи, имена, события и организации, представленные в данной игре, являются вымышленными. Любые совпадения с реальными людьми, организациями или событиями — случайны и непреднамеренны.<br><br><hr><br>ООО «Новартис Фарма»<br>Ленинградский проспект, д. 70<br>Москва, 125315<br>Россия<br>Тел: +7 (495) 967 12 70<br>Факс: +7 (495) 967 12 68<br><br>www.novartis.ru<br><br>11564571/IPT/DIG/12.25/0</span>',
        positionTop: true,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"6", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/city.jpg`,
    },
    {
        name: 'Надя',
        text: 'Я — Надя, медсестра, буду с Вами работать. Едем сразу в поликлинику! Вас уже ждут пациенты.',
        positionTop: false,
        bitTitle: false,
        textIsMaxSize: false,
        buttons: [
            {text: "В машину!", type: "nextStep", gotoStep:"7", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/station.jpg`,
    },
    {
        name: 'Надя',
        text: 'Вам тут работы хватит с лихвой! Город вроде маленький, а даже с ПНГ есть несколько пациентов.',
        positionTop: false,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"8", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/car.jpg`,
    },
    {
        name: 'Надя',
        text: 'У Вас есть опыт назначения лечения при ПНГ?',
        positionTop: false,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Да", type: "YesNo", gotoStep:"9", value: false, redColor: false, answered: false},
            {text: "Нет", type: "YesNo", gotoStep:"9", value: true, redColor: false, answered: false}
        ],
        background: `${base}/images/car.jpg`,
    },
    {
        name: '',
        text: 'Добро пожаловать в городскую поликлинику Северокрайска!',
        positionTop: false,
        bitTitle: false,
        textIsMaxSize: false,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"10", value: false, redColor: false, answered: false}
        ],
        background: `${base}/images/hospital.jpg`,
    },
    {
        name: '',
        text: '',
        positionTop: false,
        bitTitle: false,
        textIsMaxSize: true,
        buttons: [
            {text: "Войти в свой кабинет", gotoStep:"11", type: "Enter", value: true, redColor: false, answered: false},
        ],
        background: `${base}/images/enter.jpg`,
    }
];

// function getCookie(name: any) {
//     const matches = document.cookie.match(
//         new RegExp(
//             "(?:^|; )" +
//             name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") +
//             "=([^;]*)"
//         )
//     );
//     return matches ? decodeURIComponent(matches[1]) : undefined;
// }
function setCookie(name: any, value: any, days = 7) {
    try { localStorage.setItem(String(name), String(value)); } catch {}
}

function getCookie(name: any): string | undefined {
    try {
        const v = localStorage.getItem(String(name));
        return v === null ? undefined : v;
    } catch { return undefined; }
}


export const WelcomePage = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [userData, setUserData] = useState<UserData | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [queryData, setQueryData] = useState<any>(null);
    // @ts-ignore
    const { muted, toggleMuted } = useSound();
    const handleSound = () => {
        toggleMuted(); // тут меняем значение в контексте
    }


    const step = getCookie('step');
    const branch = getCookie('branch');



    useEffect(() => {
        if (step){
            navigate('/cabinet');
        }else{
            setLoaded(true)
        }
    }, [step]);


    const handleClick = (type: string, value: boolean, step: string, patient: string) => {
        if (type === "nextStep") {
            setCurrentStep(Number(step));
        } else if (type === "YesNo") {
            const branch = value ? "0" : "1";
            setCookie('branch', branch)
            setCurrentStep(Number(step));
        } else if (type === "Enter") {
            navigate('/learn');
        }
    };


    return (
        <div className={styles.Container}>
            <>
                <img src={steps[currentStep].background} className={steps[currentStep].positionTop ? styles.stepBg : styles.stepBg } alt="Step" />
                {loaded && (
                    <>
                        {!muted ?
                            <img src={`${base}/images/sound.svg`} className={styles.soundMutedIcon} alt="soundMutedIcon" onClick={handleSound}/>
                            :
                            <img src={`${base}/images/sound_off.svg`} className={styles.soundMutedIcon} alt="soundMutedIcon" onClick={handleSound}/>
                        }
                        {(steps[currentStep].name !== "" || steps[currentStep].text !== "") &&
                            <MessageBubble label={steps[currentStep].name} positionTop={steps[currentStep].positionTop} text={steps[currentStep].text} textHeight="auto" textIsMaxSize={steps[currentStep].textIsMaxSize} bitTitle={steps[currentStep].bitTitle} noMargin={true} offsetTop={59} topFull={true}/>
                        }
                        <div className={styles.stepButtons}>
                        {steps[currentStep].buttons.map((button, index) => (
                            <Button
                                label={button.text}
                                redColor={button.redColor}
                                answered={button.answered}
                                onClick={()=>handleClick(button.type, button.value, button.gotoStep, '')}
                            />
                        ))}
                        </div>
                    </>
                )}


            </>
        </div>
    );
};
